import { queryClient } from '../../api'
import { MOVEMENTS_QUERY_KEY } from '../movement'
import { PRODUCTS_LEFTOVERS_QUERY_KEYS } from './queryKeys'

export const invalidateProductLeftovers = () => {
  queryClient.invalidateQueries([MOVEMENTS_QUERY_KEY])
  queryClient.invalidateQueries({
    predicate: query => query.queryKey.includes(PRODUCTS_LEFTOVERS_QUERY_KEYS),
  })
}
